var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"id":"menu","d":"M0,3 L24,3 L24,7 L0,7 L0,3 Z M0,10 L24,10 L24,14 L0,14 L0,10 Z M0,17 L24,17 L24,21 L0,21 L0,17 Z","fill":_vm.iconColor}})
}
var staticRenderFns = []

export { render, staticRenderFns }